import { render, staticRenderFns } from "./coursequestionbank.vue?vue&type=template&id=858c8792&scoped=true"
import script from "./coursequestionbank.vue?vue&type=script&lang=js"
export * from "./coursequestionbank.vue?vue&type=script&lang=js"
import style0 from "./coursequestionbank.vue?vue&type=style&index=0&id=858c8792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "858c8792",
  null
  
)

export default component.exports